"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceDisplayBlock = void 0;
var react_1 = __importStar(require("react"));
var LoadersAndProgress_1 = require("../../LoadersAndProgress");
var ActionMenu_1 = require("../../ActionMenu");
var Typo_1 = require("../../Typo");
var injectHttps_1 = require("../../../utils/injectHttps");
var styled_1 = require("./styled");
var PDFEmbed_1 = __importDefault(require("../../PDFInput/comps/PDFEmbed"));
var react_player_1 = __importDefault(require("react-player"));
var icons_1 = require("../../../icons");
var FilePdf = icons_1.icons.FilePdf, ImageSquare = icons_1.icons.ImageSquare, SpeakerHigh = icons_1.icons.SpeakerHigh, File = icons_1.icons.File, VideoCamera = icons_1.icons.VideoCamera;
var iconsConfig = { FilePdf: FilePdf, ImageSquare: ImageSquare, SpeakerHigh: SpeakerHigh, File: File, VideoCamera: VideoCamera };
var ResourceDisplayBlock = function (_a) {
    var _resources = _a.resources, filesLength = _a.filesLength, uploadProgress = _a.uploadProgress, removeResource = _a.removeResource, invert = _a.invert;
    var _b = (0, react_1.useState)(__spreadArray([], _resources, true)), resources = _b[0], setResources = _b[1];
    (0, react_1.useEffect)(function () {
        setResources((_resources));
    }, [_resources, resources]);
    var downloadResource = function (url) {
        window.open((0, injectHttps_1.injectHttps)(url));
    };
    var genInfoBand = function (_a) {
        var d = _a.d, icon = _a.icon;
        var IconComp = iconsConfig[icon];
        return (react_1.default.createElement(styled_1.StyledMediaBand, { invert: invert },
            react_1.default.createElement(IconComp, { size: 16 }),
            react_1.default.createElement("div", { style: { width: '14rem' } },
                react_1.default.createElement(Typo_1.SANS_0, { style: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    } }, d === null || d === void 0 ? void 0 : d.originalFilename))));
    };
    var genResourceBlock = function (d) {
        switch (true) {
            case ['application/pdf'].indexOf(d === null || d === void 0 ? void 0 : d.contentType) !== -1:
                return (react_1.default.createElement(styled_1.StyledMediaBlock, null,
                    react_1.default.createElement(PDFEmbed_1.default, { filePath: d === null || d === void 0 ? void 0 : d.publicUrl, fileName: d === null || d === void 0 ? void 0 : d.originalFilename, fileID: d === null || d === void 0 ? void 0 : d.id }),
                    genInfoBand({ d: d, icon: "FilePdf" })));
            case ['image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/jpeg'].indexOf(d === null || d === void 0 ? void 0 : d.contentType) !== -1:
                return (react_1.default.createElement(styled_1.StyledMediaBlock, null,
                    react_1.default.createElement("img", { alt: "Thumbnail", src: d.mediaLink, style: { width: '100%' } }),
                    genInfoBand({ d: d, icon: "ImageSquare" })));
            case ['video/mp4'].indexOf(d === null || d === void 0 ? void 0 : d.contentType) !== -1:
                return (react_1.default.createElement(styled_1.StyledMediaBlock, null,
                    react_1.default.createElement(react_player_1.default, { id: d === null || d === void 0 ? void 0 : d.id, url: d === null || d === void 0 ? void 0 : d.publicUrl, controls: true, width: "100%" }),
                    genInfoBand({ d: d, icon: "VideoCamera" })));
            case ['audio/wav', 'audio/mp3', 'audio/mpeg'].indexOf(d === null || d === void 0 ? void 0 : d.contentType) !== -1:
                return (react_1.default.createElement(styled_1.StyledMediaBlock, null,
                    react_1.default.createElement(styled_1.StyledAudioElement, { key: "".concat(d === null || d === void 0 ? void 0 : d.id), controls: true, src: d === null || d === void 0 ? void 0 : d.publicUrl, controlsList: "nodownload noplaybackrate" // to hide controls
                     }),
                    genInfoBand({ d: d, icon: "SpeakerHigh" })));
            default:
                return (react_1.default.createElement(styled_1.StyledDefaultBlock, { id: d === null || d === void 0 ? void 0 : d.id }, genInfoBand({ d: d, icon: 'File' })));
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null, resources === null || resources === void 0 ? void 0 :
        resources.map(function (file) { return (react_1.default.createElement(styled_1.StyledBlock, { style: { position: 'relative' }, invert: invert, key: file === null || file === void 0 ? void 0 : file.id },
            genResourceBlock(file),
            react_1.default.createElement("div", { style: { position: 'absolute', top: '0', right: '0' } },
                react_1.default.createElement(ActionMenu_1.ActionMenu, { ButtonComp: "ButtonPrimary", invert: invert, actions: [
                        {
                            display: "Delete",
                            onClick: function () { return removeResource(file === null || file === void 0 ? void 0 : file.id); },
                        },
                        {
                            display: "Download",
                            onClick: function () { return downloadResource((file === null || file === void 0 ? void 0 : file.mediaLink) || (file === null || file === void 0 ? void 0 : file.publicUrl)); },
                        },
                    ] })))); }),
        Array.from({ length: filesLength }).map(function (_, index) { return (react_1.default.createElement(styled_1.StyledBlockWrapper, { key: index }, (react_1.default.createElement(styled_1.StyledBlock, { invert: invert },
            react_1.default.createElement(LoadersAndProgress_1.ProgressBar, { progress: uploadProgress, invert: invert, text: uploadProgress && uploadProgress !== 100 ? "".concat(uploadProgress, "%") : 'Almost Done...' }))))); })));
};
exports.ResourceDisplayBlock = ResourceDisplayBlock;
